import { __extends } from "tslib";
import { fetchFrequentlyAskedQuestion } from '@gn-audio/core/api/knowledge-base';
import { GroupRestrictedSpotType } from 'src/Shared/enums/group-restricted-spot-type.enum';
import { generateFaqPath } from '../utils/generate-faq-path';
import { generateFaqUrl } from '../utils/generate-faq-url';
import { ContactSupportSectionController } from 'src/Feature/ContactSupport/app';
var SingleFaqSpotController = (function (_super) {
    __extends(SingleFaqSpotController, _super);
    function SingleFaqSpotController($rootScope, $scope, $q, productContextService, faqContextService, faqTeasersService, spotsDisplayControl) {
        var _this = _super.call(this, $scope, productContextService, spotsDisplayControl, GroupRestrictedSpotType.Other) || this;
        _this.$rootScope = $rootScope;
        _this.$scope = $scope;
        _this.$q = $q;
        _this.productContextService = productContextService;
        _this.faqContextService = faqContextService;
        _this.faqTeasersService = faqTeasersService;
        _this.$scope.faqItemLoaded = false;
        return _this;
    }
    SingleFaqSpotController.prototype.$onInit = function () {
        var _this = this;
        this.$scope.excludeFaqCodes = [this.getFaqCode()];
        _super.prototype.$onInit.call(this);
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            _this.$scope.group = group;
            _this.$q.when(fetchFrequentlyAskedQuestion(group.groupId, _this.getFaqCode()))
                .then(function (faqItem) {
                _this.$scope.faqItemLoaded = true;
                _this.$scope.faqItem = faqItem;
                _this.faqTeasersService.teasersVisible = !!faqItem;
                _this.faqContextService.setContext(faqItem);
                _this.$rootScope.$broadcast('related-faqs', (faqItem === null || faqItem === void 0 ? void 0 : faqItem.relatedFrequentlyAskedQuestions) || []);
                _this.$rootScope.$broadcast('related-videos', (faqItem === null || faqItem === void 0 ? void 0 : faqItem.relatedVideos) || []);
            });
        });
        this.$scope.getFaqPdfUrl = function () {
            var _a = _this.$scope, faqItem = _a.faqItem, group = _a.group;
            var shareFaqItemUrl = generateFaqUrl(group, faqItem.id, true);
            var baseExportUrl = "/support/export/faq?pdf=1&shareUrl=" + shareFaqItemUrl;
            return faqItem ? baseExportUrl + "&id=" + faqItem.id + "&groupid=" + group.groupId : '';
        };
        this.$scope.getFaqItemUrl = function (faqItem) {
            return generateFaqUrl(_this.$scope.group, faqItem.id, true);
        };
        this.$scope.hasFaqTeasers = function () {
            var _a;
            return ((_a = _this.$scope.faqTeasers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        };
        this.$scope.getFaqItemPath = function (faqItem) {
            return generateFaqPath(faqItem);
        };
        this.$scope.onFaqTeasersLoad = function (faqTeasers) {
            _this.$scope.faqTeasers = faqTeasers;
        };
    };
    SingleFaqSpotController.prototype.getFaqCode = function () {
        var locationPathName = location.pathname;
        if (locationPathName.slice(-1) === '/') {
            locationPathName = locationPathName.slice(0, -1);
        }
        var pathNames = locationPathName.split('/');
        return pathNames[pathNames.length - 1];
    };
    SingleFaqSpotController.$inject = [
        '$rootScope',
        '$scope',
        '$q',
        'productContextService',
        'faqContextService',
        'faqTeasersService',
        'dynamicPagesSpotsDisplayOptionsService',
    ];
    return SingleFaqSpotController;
}(ContactSupportSectionController));
export { SingleFaqSpotController };
